import { resource } from '@/plugins/http'

// Rota para configuracoes de tenants
export default resource('/v1/settings/me/tenants')



// WEBPACK FOOTER //
// ./src/store/resources/tenants.js